<template>
  <div class="content-section">
    <h2 class="page-title">合同管理</h2>
    <el-main style="min-height: 200px" v-loading="loading" element-loading-text="拼命加载中"
             element-loading-spinner="el-icon-loading"
             element-loading-background="rgba(0, 0, 0, 0.8)">
      <div v-if="keyCode == '1'" style="margin-bottom: 30px;">
        <div style="background-color: #f9f9f9; padding: 20px; border-radius: 8px; border-left: 4px solid #1a3a6c;line-height: 200%">
          <h4>代理服务合同 - 编号：{{contractInfo.F_Id}}</h4>
          <p>合同状态：<el-tag :type="contractInfo.F_SignStatus==1?'warning':contractInfo.F_SignStatus==2?'success':'danger'">{{contractInfo.F_SignStatus==1?'签约中':contractInfo.F_SignStatus==2?'已签约':'未签约'}}</el-tag></p>
          <p>合同开始日期：{{contractInfo.F_StartDate.substring(0,10)}}</p>
          <p>合同结束日期：{{contractInfo.F_EndDate.substring(0,10)}}</p>
          <p>认证类型：{{contractInfo.F_Type==1?'运营中心':'代理'}}</p>
          <button class="btn btn-primary btn-sm" @click="getInfo()">查看合同</button>
          <button class="btn btn-primary btn-sm" @click="downLoadHT(contractInfo.F_Id)">下载合同</button>
          <!--<button class="btn btn-success btn-sm" @click="getInvioceList(contractInfo.F_Id)">查看发票</button>-->
        </div>
      </div>
      <div v-else style="background-color: #f9f9f9; padding: 20px;">
        {{MessageContent}}
      </div>
    </el-main>
    <el-table
      :data="ContractData"
      height="600"
      v-loading="tableLoading"
      border
      style="width: 100%">
      <el-table-column
        prop="F_Id"
        label="合同编号"
        align="center"
        header-align="center"
       >
      </el-table-column>
      <el-table-column
        prop="F_CompanyName"
        label="企业名称"
        align="center"
        header-align="center"
        >
      </el-table-column>
      <el-table-column
        prop="F_CaseName"
        align="center"
        header-align="center"
        label="项目名称">
      </el-table-column>
      <el-table-column
        prop="F_SignStatus"
        align="center"
        header-align="center"
        label="签约状态">
        <template slot-scope="scope">
          <el-tag type="info" v-if="scope.row.F_SignStatus == 0" size="medium">未签约</el-tag>
          <el-tag type="primary" v-else-if="scope.row.F_SignStatus == 1" size="medium">签约中</el-tag>
          <el-tag v-else-if="scope.row.F_SignStatus == 2" size="medium" type="success">签约通过</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        header-align="center"
        width="150"
        fixed="right"
        label="操作">
        <template slot-scope="scope">
          <button v-if="scope.row.F_QYSUpState == 1" class="btn btn-sm btn-primary" @click="onDisplay(scope.row)">预览</button>
          <!--<button class="btn btn-sm btn-primary" @click="onDisplay(scope.row.F_Id)">发票</button>-->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next"
      :page-size="PageSize"
      @current-change="onCurrentChange"
      @size-change="onSizeChange"
      :total="total">
    </el-pagination>
    <el-dialog center widh="600px" title="发票" :visible.sync="dialogTableVisible" :close-on-click-modal="false">
      <el-table v-loading="tableLoadding" :data="voiceList">
        <el-table-column property="F_FileName" label="文件名称">
          <template slot-scope="scope">
            <el-link @click="download(scope.row)" type="primary">{{scope.row.F_FileName}}</el-link>
          </template>
        </el-table-column>
        <el-table-column property="F_CreateTime" label="上传时间"></el-table-column>
        <!--<el-table-column header-align="center" align="center" width="120" label="操作">-->
          <!--<template slot-scope="scope">-->
            <!--<el-button type="text" size="small" @click="downLoadHT(scope.row)">下载</el-button>-->
          <!--</template>-->
        <!--</el-table-column>-->
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" plain @click="dialogTableVisible=false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        url: {
          GetMyAgentContract: SZH.assets.api + '/Custom/GetMyAgentContract',
          GetMyAgentContractPageUrl: SZH.assets.api + '/Custom/GetMyAgentContractPageUrl',
          GetPagingCaseContracts: SZH.assets.api + '/Custom/GetPagingCaseContracts',
          GetMyCaseContractPageUrl: SZH.assets.api + '/Custom/GetMyCaseContractPageUrl',
          GetInvoiceByContract: SZH.assets.api + '/Custom/GetInvoiceByContract',
          DownloadContract: SZH.assets.api + '/Custom/DownloadContract',
        },
        contractInfo:{},
        keyCode:'',
        MessageContent:'',
        ContractData:[],
        loading:false,
        queryParams:{
          keyWord:''
        },
        PageIndex:1,
        PageSize:50,
        total:0,
        tableLoading:false,
        dialogTableVisible:false,
        tableLoadding:false,
        voiceList:[]
      }
    },
    methods: {
      downLoadHT(id){
        let self = this;
        self.$http.post(self.url.DownloadContract,{
          keyValue:id
        })
          .then(result => {
            if (result.state == true) {
              window.open(SZH.assets.image +'/' + result.data);
            } else {
              self.$message.error(result.message);
            }
          }, () => {
            // 请求失败
            self.$message.error('操作失败，请检查您的网络是否可用。');
          });
      },

      getInvioceList(id){
        let self = this;
        self.dialogTableVisible = true;
        self.tableLoadding = true;
        self.$http.post(self.url.GetInvoiceByContract,{
          contractId:id
        })
          .then(result => {
            if (result.state == true) {
              self.voiceList = result.data;
              self.tableLoadding = false;
            } else {
              self.voiceList = [];
              self.tableLoadding = false;
              // self.$message.error(result.message);
            }
          }, () => {
            self.tableLoadding = false;
            // 请求失败
            self.$message.error('操作失败，请检查您的网络是否可用。');
          });
      },
      onSizeChange(val) {
        this.PageSize = val;
        this.loadList();
      },
      onCurrentChange(val) {
        this.PageIndex = val;
        this.loadList();
      },
      getInfo(){
        let self = this;
        self.loading = true;
        self.$http.post(self.url.GetMyAgentContractPageUrl,{
          keyValue:self.contractInfo.F_Id
        })
          .then(result => {
            if (result.state == true) {
              self.loading = false;
              window.open(result.data,'_blank')
            } else {
              self.loading = false;
              self.$message.error(result.message);
            }
          }, () => {
            self.loading = false;
            // 请求失败
            self.$message.error('操作失败，请检查您的网络是否可用。');
          });
      },
      onDisplay(row){
        let self = this;
        self.loading = true;
        self.$http.post(self.url.GetMyCaseContractPageUrl,{
          keyValue:row.F_Id
        })
          .then(result => {
            if (result.state == true) {
              self.loading = false;
              window.open(result.data,'_blank')
            } else {
              self.loading = false;
              self.$message.error(result.message);
            }
          }, () => {
            self.loading = false;
            // 请求失败
            self.$message.error('操作失败，请检查您的网络是否可用。');
          });
      },
      loadData(){
        let self = this;
        self.loading = true;
        self.$http.post(self.url.GetMyAgentContract,{})
          .then(result => {
            if (result.state == true) {
              self.contractInfo = result.data.contract;
              self.keyCode = result.data.keyCode;
              self.MessageContent = result.data.MessageContent;
              self.loading = false;
            } else {
              self.contractInfo = {};
              self.keyCode = '';
              self.MessageContent = '';
              self.loading = false;
              self.$message.error(result.message);
            }
          }, () => {
            self.loading = false;
            // 请求失败
            self.$message.error('操作失败，请检查您的网络是否可用。');
          });
      },
      loadList(){
        let self = this;
        self.tableLoading = true;
        self.$http.post(self.url.GetPagingCaseContracts,{
          Data:self.queryParams,
          PageIndex:self.PageIndex,
          PageSize:self.PageSize
        })
          .then(result => {
            if (result.state == true) {
              self.ContractData = result.data.Data;
              self.tableLoading = false;
              self.total = result.data.TotalCount;
            } else {
              self.ContractData = [];
              self.total = 0;
              self.tableLoading = false;
              self.$message.error(result.message);
            }
          }, () => {
            self.loading = false;
            // 请求失败
            self.$message.error('操作失败，请检查您的网络是否可用。');
          });
      },
    },
    computed: {},
    components: {
    },
    mounted() {
      this.loadData();
      this.loadList();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Me/ContractManagement/ContractManagement.vue